import gql from 'graphql-tag';

export const GET_REPORT_PORTFOLIOS = gql`
  query getChildPortfolio(
    $customFilter: ChildPortfolioCustomFilter!
    $filter: PortfolioFilter
    $ChildID: [Int!]
    $childStatus: String
    $pagination: Pagination
    $time: Datetime!
  ) {
    getChildPortfolio(
      customFilter: $customFilter
      filter: $filter
      ChildID: $ChildID
      childStatus: $childStatus
      pagination: $pagination
    ) {
      totalCount
      data {
        ID
        fkChild
        fkTerm
        title
        coverImage
        coverImagePresignedURL
        coverDescription
        postConferenceNote
        postConferenceNotePlans
        myPhysicalSelf
        myPsycoSocialSelf
        myThinkingAndCommunicationSelf
        behaviourOfChild
        childInterestsAndStrengths
        summary
        status
        approverNote
        portfolioURL
        portfolioUrlPresigned
        summativeReportNote
        active
        createdAt
        updatedAt
        rejectNote
        rejectedAt
        isMigrated
        areaOfInterest
        areaOfRecommendation
        summaryLastSyncTime
        userByRejectedBy {
          ID
          firstname
          lastname
        }
        term {
          ID
          name
          year
        }
        approvedAt
        fkLevel
        fkClass
        class {
          ID
          fkLevel
          label
        }
        level {
          ID
          label
          code
          fromMonth
          toMonth
        }
        userByApprovedBy {
          ID
          firstname
          lastname
        }
        child {
          ID
          firstname
          lastname
          imageKey
          imageKeyPresignedURL
          currentClass {
            ID
            class {
              ID
              label
              centre {
                label
              }
            }
          }
          childClasses(filter: { active: [{ eq: [true, false] }] }) {
            data {
              ID
              class {
                ID
                label
                centre {
                  label
                }
              }
            }
          }
          childClassAt(time: $time) {
            ID
            class {
              ID
              label
              centre {
                label
              }
            }
          }
          currentLevel {
            level {
              ID
              label
            }
            program {
              ID
              label
            }
          }
          closestLevel {
            level {
              ID
              label
            }
          }
        }
      }
    }
  }
`;

export const GET_PORTFOLIO_BY_ID = gql`
  query portfolioByID($id: Int!, $classID: Int!) {
    portfolioByID(id: $id) {
      ID
      fkChild
      fkTerm
      title
      coverImage
      coverImagePresignedURL
      coverDescription
      postConferenceNote
      postConferenceNotePlans
      myPhysicalSelf
      myPsycoSocialSelf
      myThinkingAndCommunicationSelf
      behaviourOfChild
      childInterestsAndStrengths
      summary
      status
      approverNote
      portfolioURL
      portfolioUrlPresigned
      summativeReportNote
      active
      createdAt
      rejectNote
      rejectedAt
      isMigrated
      areaOfInterest
      areaOfRecommendation
      summaryLastSyncTime
      portfolioClassTeachers {
        data {
          ID
          fkClassTeacher
        }
      }
      userByRejectedBy {
        ID
        firstname
        lastname
      }
      approvedAt
      fkLevel
      fkClass
      class {
        ID
        fkLevel
        label
      }
      level {
        ID
        label
        code
        fromMonth
        toMonth
      }
      userByApprovedBy {
        ID
        firstname
        lastname
      }
      term {
        ID
        year
      }
      portfolioChildLearningGoalEvaluations {
        data {
          ID
          fkChildEvaluation
          childLearningGoalEvaluation {
            ID
            fkChild
            fkLevel
            fkTerm
            fkDomain
            parentDomainValue
            value
            domain {
              learningGoalsByClass(classID: $classID) {
                data {
                  ID
                  fkDomain
                  title
                  fkLearningGoal
                }
              }
            }
            summary
          }
        }
      }
      portfolioClassActivities {
        data {
          ID
          fkClassActivity
          fkDomain
          classActivity {
            ID
            title
            description
            interpretation
            updatedAt
            createdAt
            publishedAt
            displayDate
            type
            classActivityLearningGoals {
              data {
                learningGoal {
                  ID
                  title
                }
              }
            }
            classActivityImages {
              data {
                ID
                uRL
                urlPresigned
                type
                caption
              }
            }
            classActivityDevelopmentalAndLearningAreas {
              data {
                ID
                fkDomain
                fkClassActivity
                fkSubDomain
                domain {
                  title
                }
                learningGoal {
                  title
                }
              }
            }
          }
        }
      }
      child {
        ID
        firstname
        lastname
        imageKey
        imageKeyPresignedURL
        dateOfBirth
        currentClass {
          ID
          class {
            ID
            label
            centre {
              label
            }
            classTeachers {
              data {
                user(filter: { active: [true, false] }) {
                  firstname
                  lastname
                }
              }
            }
          }
        }
        childClasses(filter: { active: [{ eq: [true, false] }] }) {
          data {
            ID
            class {
              ID
              label
              centre {
                label
              }
            }
          }
        }
        currentLevel {
          level {
            ID
            label
            code
          }
          program {
            ID
            label
          }
        }
        closestLevel {
          level {
            ID
            label
          }
        }
      }
    }
  }
`;

export const GET_DOMAIN_LISTING = gql`
  query getListDomain(
    $childID: Int
    $levelID: [Int]
    $classID: Int!
    $fkLevel: FilterOnField
    $version: Int
    $isCHDPortfolioDomain: Boolean
    $pagination: Pagination
    $filter: DomainFilter
    $evaluationSort: [String!]
  ) {
    getListDomain(
      childID: $childID
      levelID: $levelID
      classID: $classID
      pagination: $pagination
      version: $version
      isCHDPortfolioDomain: $isCHDPortfolioDomain
      filter: $filter
    ) {
      totalCount
      data {
        ID
        title
        isChdPortfolioDomain
        learningGoalsByClass(classID: $classID) {
          data {
            ID
            title
            fkLearningGoal
          }
        }
        evaluationLabels(
          filter: { fkLevel: $fkLevel }
          pagination: { sort: $evaluationSort }
        ) {
          data {
            ID
            title
            index
          }
        }
      }
    }
  }
`;

export const FIND_OBSERVATION_LIST = gql`
  query findClassActivities(
    $filterDto: ClassActivityFilterDto!
    $filter: ClassActivityFilter
    $pagination: Pagination
  ) {
    findClassActivities(
      filterDto: $filterDto
      filter: $filter
      pagination: $pagination
    ) {
      totalCount
      data {
        ID
        title
        description
        interpretation
        updatedAt
        createdAt
        publishedAt
        displayDate
        status
        type
        classActivityLearningGoals {
          data {
            learningGoal {
              ID
              title
            }
          }
        }
        classActivityImages {
          data {
            ID
            uRL
            urlPresigned
            type
            caption
          }
        }
        classActivityDevelopmentalAndLearningAreas {
          data {
            ID
            fkDomain
            fkClassActivity
            fkSubDomain
            domain {
              title
            }
            learningGoal {
              title
            }
          }
        }
      }
    }
  }
`;

export const SAVE_PORTFOLIO = gql`
  mutation saveChildPortfolio(
    $portfolioID: Int
    $dto: PortfolioDto!
    $classTeacherIDs: [Int!]
  ) {
    saveChildPortfolio(
      portfolioID: $portfolioID
      dto: $dto
      classTeacherIDs: $classTeacherIDs
    ) {
      ID
    }
  }
`;

export const SAVE_PORTFOLIO_PHOTO_UPLOAD = gql`
  mutation getPortfolioPhotoUploadURL($IDChild: Int!, $file: Upload!) {
    getPortfolioPhotoUploadURL(IDChild: $IDChild, file: $file) {
      Url
      Key
      Filename
    }
  }
`;

export const GET_TERM_BY_YEAR = gql`
  query getPortfolioTermByYear($year: [Int!]) {
    getPortfolioTermByYear(year: $year) {
      year
      termList {
        ID
        name
        from
        to
        year
        termCode
      }
    }
  }
`;

export const PREPARE_PDF = gql`
  mutation exportPortfolioPreviewPdf($dto: PortfolioDto!) {
    exportPortfolioPreviewPdf(dto: $dto)
  }
`;

export const PORTFOLIO_BY_CHILD = gql`
  query portfoliosByFkChild(
    $childId: Int!
    $filter: PortfolioFilter
    $pagination: Pagination
  ) {
    portfoliosByFkChild(
      childId: $childId
      filter: $filter
      pagination: $pagination
    ) {
      totalCount
      data {
        ID
        title
        status
        title
        fkTerm
        createdAt
        updatedAt
        rejectNote
        rejectedAt
        userByRejectedBy {
          ID
          firstname
          lastname
        }
        term {
          ID
          name
          year
        }
        isMigrated
        child {
          ID
          firstname
          lastname
          imageKey
          imageKeyPresignedURL
          currentLevel {
            level {
              ID
              label
            }
          }
          currentClass {
            class {
              ID
              label
            }
          }
        }
      }
    }
  }
`;

export const DELETE_PORTFOLIO = gql`
  mutation deleteChildPortfolio($portfolioID: Int!) {
    deleteChildPortfolio(portfolioID: $portfolioID)
  }
`;

export const GET_HEIGHT_AND_WEIGHT = gql`
  query getMeasurementsForChildByFromAndToDate(
    $childId: Int!
    $to: Datetime!
    $from: Datetime
  ) {
    getMeasurementsForChildByFromAndToDate(
      childId: $childId
      to: $to
      from: $from
    ) {
      height {
        height
        xValue
        xLabel
      }
      weight {
        weight
        xValue
        xLabel
      }
    }
  }
`;

export const CHANGE_PORTFOLIO_STATUS = gql`
  mutation changeChildPortfolioStatus(
    $id: Int!
    $status: PortfolioStatus!
    $rejectedNote: String
  ) {
    changeChildPortfolioStatus(
      id: $id
      status: $status
      rejectedNote: $rejectedNote
    ) {
      ID
    }
  }
`;

export const GET_CHILD_EVALUATION = gql`
  query getChildSemesterEvaluation(
    $childId: Int!
    $levelId: Int!
    $domainId: Int!
    $termId: Int!
    $filter: ChildLearningGoalEvaluationFilter
  ) {
    getChildSemesterEvaluation(
      childId: $childId
      levelId: $levelId
      domainId: $domainId
      termId: $termId
      filter: $filter
    ) {
      ID
      fkChild
      fkLevel
      fkTerm
      fkDomain
      parentDomainValue
      value
      summary
      areaOfInterest
      areaOfRecommendation
      active
      createdAt
      updatedAt
    }
  }
`;

export const GET_CHILD_BY_ID = gql`
  query getChildProfileByID($idChild: Int!) {
    getChildProfileByID(idChild: $idChild) {
      ID
      firstname
      lastname
      imageKey
      imageKeyPresignedURL
      dateOfBirth
      currentClass {
        class {
          ID
          label
          classTeachers {
            data {
              ID
              user(filter: { active: [true, false] }) {
                ID
                firstname
                lastname
              }
            }
          }
        }
      }
      currentLevel {
        level {
          ID
          label
          code
        }
      }
    }
  }
`;

export const SAVE_CHILD_EVALUATION = gql`
  mutation insertOrUpdateChildLearningGoalEvaluation(
    $IDChildLearningGoalEvaluation: Int
    $dto: ChildLearningGoalEvaluationDto!
  ) {
    insertOrUpdateChildLearningGoalEvaluation(
      IDChildLearningGoalEvaluation: $IDChildLearningGoalEvaluation
      dto: $dto
    ) {
      ID
    }
  }
`;

export const SAVE_PORTFOLIO_UPLOAD_URL = gql`
  mutation getPortfolioPdfUploadURL($file: Upload!) {
    getPortfolioPdfUploadURL(file: $file) {
      Url
      Key
    }
  }
`;

export const BULK_PUBLISH_PORTFOLIOS = gql`
  mutation changeBulkPortfoliosStatusToPublished($id: [Int!]) {
    changeBulkPortfoliosStatusToPublished(id: $id) {
      data {
        ID
      }
    }
  }
`;

export const GET_CHILD_AREA_OF_INTEREST_AND_RECOMMENDATION = gql`
  query getChildAreaOfInterestAndRecommendation(
    $IDChild: Int!
    $FkTerm: Int
    $FkLevel: Int
  ) {
    getChildAreaOfInterestAndRecommendation(
      IDChild: $IDChild
      FkTerm: $FkTerm
      FkLevel: $FkLevel
    ) {
      AreaOfInterest
      AreaOfRecommendation
      Child
    }
  }
`;

export const GET_HISTORICAL_CENTRE_AND_CLASSES_OF_CHILD = gql`
  query GetHistoricalCentreAndClassesofChild($childId: Int!, $centreId: Int) {
    GetHistoricalCentreAndClassesofChild(
      childId: $childId
      centreId: $centreId
    ) {
      Items {
        ID
        Label
        Levels {
          ID
          Label
          Classes {
            ID
            Label
            From
            To
          }
        }
      }
    }
  }
`;

export const S3_PATH_TO_PRESIGNED_URLS = gql`
  query s3PathToPresignedURLS($urls: [String!]!) {
    s3PathToPresignedURLS(urls: $urls)
  }
`;
